module.exports = __webpack_public_path__ + "media/audio43.469bca42.mp3";